<div class="tracker-page">
  <div class="page-header">
    <div class="header-text">
      <div class="header-text__title-row">
        <h2>Rastreador</h2>
        <span
          class="live-tag"
          [class.live-tag--connected]="socketStatus === 'connected'"
          [class.live-tag--connecting]="socketStatus === 'connecting'"
          [class.live-tag--offline]="socketStatus === 'disconnected'"
          [attr.title]="
            socketStatus === 'connected'
              ? 'Socket conectado — posições em tempo real'
              : socketStatus === 'connecting'
                ? 'Conectando ao socket…'
                : 'Socket desconectado — use Atualizar para sincronizar'
          "
        >
          <span class="live-tag__dot" aria-hidden="true"></span>
          {{ liveStatusLabel }}
        </span>
      </div>
      <p>
        @if (!loading && !errorMessage) {
          Exibindo {{ mappedCount }} de {{ apiPositionsTotal }} veículos rastreados
          @if (refreshing) {
            <span class="header-text__badge header-text__badge--muted">atualizando…</span>
          }
        } @else {
          Última posição da frota no mapa
        }
      </p>
    </div>
    <div class="header-actions">
      <button
        nz-button
        nzType="default"
        [disabled]="loading || mappedCount === 0"
        (click)="fitFleet()"
      >
        <i nz-icon nzType="expand" nzTheme="outline"></i>
        Ajustar visão
      </button>
      <button
        nz-button
        nzType="primary"
        [disabled]="loading || refreshing"
        (click)="loadMapData(true)"
      >
        <i nz-icon nzType="reload" nzTheme="outline"></i>
        Atualizar
      </button>
    </div>
  </div>

  @if (errorMessage) {
    <nz-alert
      class="tracker-alert"
      nzType="error"
      nzShowIcon
      [nzMessage]="errorMessage"
      [nzAction]="retryTpl"
    ></nz-alert>
    <ng-template #retryTpl>
      <button nz-button nzType="link" (click)="loadMapData(true)">Tentar novamente</button>
    </ng-template>
  }

  @if (checklistWarning && !errorMessage) {
    <nz-alert
      class="tracker-alert"
      nzType="warning"
      nzShowIcon
      [nzMessage]="checklistWarning"
    ></nz-alert>
  }

  <div class="metrics-grid">
    <div class="metric-card metric-card--accent">
      <span class="metric-card__label">No mapa</span>
      <strong class="metric-card__value">{{ mappedCount }}</strong>
      <span class="metric-card__unit">após filtros</span>
    </div>
    <div class="metric-card">
      <span class="metric-card__label">Rastreados</span>
      <strong class="metric-card__value">{{
        summary?.totalVehicles ?? (apiPositionsTotal || '—')
      }}</strong>
      <span class="metric-card__unit">na API</span>
    </div>
    <div class="metric-card metric-card--motion">
      <span class="metric-card__label">Em movimento</span>
      <strong class="metric-card__value">{{ filteredMovingCount }}</strong>
      <span class="metric-card__unit">no filtro atual</span>
    </div>
    <div class="metric-card">
      <span class="metric-card__label">Parados</span>
      <strong class="metric-card__value">{{ filteredStoppedCount }}</strong>
      <span class="metric-card__unit">
        @if (summary?.lastUpdate) {
          API {{ summary!.lastUpdate | date: 'dd/MM HH:mm' }}
        } @else {
          sem atualização
        }
      </span>
    </div>
  </div>

  <div class="filters-bar">
    <input
      nz-input
      class="filters-bar__search"
      placeholder="Buscar placa"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onFiltersChange()"
    />
    <nz-select
      class="filters-bar__motion"
      [(ngModel)]="motionFilter"
      (ngModelChange)="onFiltersChange()"
      nzPlaceHolder="Status"
    >
      @for (option of motionFilterOptions; track option.value) {
        <nz-option [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
      }
    </nz-select>
    <label class="filters-bar__switch" nz-tooltip nzTooltipTitle="Somente ignição ligada">
      <nz-switch
        [(ngModel)]="ignitionOnOnly"
        (ngModelChange)="onFiltersChange()"
      ></nz-switch>
      <span>Ignição ligada</span>
    </label>
    <button nz-button nzType="default" (click)="clearFilters()">Limpar filtros</button>
  </div>

  <div class="tracker-workspace">
    <aside class="fleet-list">
      <div class="fleet-list__header">
        <strong>Frota</strong>
        <span>{{ listItems.length }}</span>
      </div>
      <div class="fleet-list__body">
        @if (!loading && listItems.length === 0) {
          <div class="fleet-list__empty">Nenhuma placa no filtro</div>
        }
        @for (item of listItems; track trackByChassis($index, item)) {
          <button
            type="button"
            class="fleet-list__item"
            [class.fleet-list__item--active]="selectedChassis === item.chassis"
            [class.fleet-list__item--moving]="item.moving"
            (click)="focusVehicle(item.chassis)"
          >
            <div class="fleet-list__row">
              <span class="fleet-list__plate">{{ item.chassis }}</span>
              <span
                class="fleet-list__badge"
                [class.fleet-list__badge--moving]="item.moving"
              >
                {{ item.moving ? 'Movimento' : 'Parado' }}
              </span>
            </div>
            <div class="fleet-list__meta">
              <span>{{ item.speed }} km/h</span>
              <span>{{ item.updatedLabel }}</span>
            </div>
            @if (item.productName || item.responsibleName) {
              <div class="fleet-list__sub">
                {{ item.productName || '—' }}
                @if (item.responsibleName) {
                  · {{ item.responsibleName }}
                }
              </div>
            }
            <span
              class="fleet-list__detail"
              role="link"
              tabindex="0"
              (click)="openDetail(item.chassis, $event)"
              (keydown.enter)="openDetail(item.chassis, $event)"
            >
              Ver detalhe
            </span>
          </button>
        }
      </div>
    </aside>

    <div class="map-surface">
      <nz-spin [nzSpinning]="loading">
        <div #mapContainer class="map-surface__canvas"></div>

        @if (!loading && mappedCount === 0 && !errorMessage) {
          <div class="map-surface__empty">
            <nz-empty
              nzNotFoundImage="simple"
              nzNotFoundContent="Nenhuma placa para exibir no mapa"
            ></nz-empty>
          </div>
        }
      </nz-spin>
    </div>
  </div>
</div>
